import { Component } from "react"

/* Components */
import { Layout, Report } from "../../components"

/* Widgets */
import { Filter, Notes, CalendarIcon, FilterIcon, DebitIcon, CreditIcon, GgrIcon, TransactionIcon, RoundIcon, ProfitIcon, FireIcon, CardsIcon, OperatorIcon, StudioIcon, ChevronIcon } from "../../widgets/Dashboard"

/* Helpers */
import { utils } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* Sweetalert */
import Swal from "../../helpers/alert"

/* REST API */
import { all, breakdown as getBreakdown } from "../../api/Dashboard"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Export Excel */
import { downloadExcel as downloadXlsx } from "react-export-table-to-excel-xlsx"

/* Export PDF */
import { jsPDF } from "jspdf"
import html2canvas from "html2canvas"

/* Router */
import { Link } from "react-router-dom"

/* Constants */
import { env } from "../../constants"

/* Translate */
import { t } from "../../translates/translate"


/* THE TABS OF THE LIST — THE VERY SAME KEYS THE COLUMN Tables.type KEEPS */
const GAME_TYPES = [
    { key: "multi", text: "Live" },
    { key: "vip", text: "VIP" },
    { key: "roulette", text: "Roulette" },
    { key: "electron", text: "Electron" },
]

/* EMPTY ANSWER — THE SAME SHAPE THE CONTROLLER SENDS */
const EMPTY = { debit: 0, credit: 0, total: 0, players: 0, rounds: 0, transactions: 0, visitors: 0, tables: 0 }


/* Page Dashboard */
class Dashboard extends Component {

    constructor() {
        super()

        /* Today In The Zone Of The Admin */
        const date = utils.getToday()

        this.state = {
            status: "loading",

            /* Data */
            totals: EMPTY,
            games: [],

            /* Breakdown — every operator by every studio, its own request and its own status */
            breakdown: [],
            breakdownStatus: "loading",
            collapsed: [],
            expanded: [],

            /* Filter */
            selected: "today",
            start: date.startDate,
            end: date.endDate,
            operators: [],
            studios: [],
            testers: false,
            vips: true,

            /* View — the first tab of the list */
            type: GAME_TYPES[0].key,
            downloading: null,
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        this.load()
    }

    /* Load Action — the token decides the scope, the filter only narrows it down */
    load = (reload = false) => {

        /* Fields */
        const { start, end, operators, studios, testers, vips } = this.state

        /* Check Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        all({
            operators: operators.map((item) => item.id).join(","),
            studios: studios.map((item) => item.id).join(","),
            start: start ? start : "",
            end: end ? end : "",
            testers,
            vips,
        }).then((response) => {
            if (response.status === 200) {
                this.setState({
                    status: "ok",
                    totals: response.data.totals ? response.data.totals : EMPTY,
                    games: Array.isArray(response.data.games) ? response.data.games : [],
                })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", totals: EMPTY, games: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", totals: EMPTY, games: [] })
            }
            else {
                this.setState({ status: "error", totals: EMPTY, games: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", totals: EMPTY, games: [] })
        })

        /* Breakdown Of The Operators — its own request, a failure of it never touches the numbers above */
        this.loadBreakdown()

    }

    /* Load The Breakdown — every operator by every studio, all the games under them */
    loadBreakdown = () => {

        /* Fields */
        const { start, end, operators, studios, testers, vips } = this.state

        /* Start Loading */
        this.setState({ breakdownStatus: "loading" })

        /* Send to REST API */
        getBreakdown({
            operators: operators.map((item) => item.id).join(","),
            studios: studios.map((item) => item.id).join(","),
            start: start ? start : "",
            end: end ? end : "",
            testers,
            vips,
        }).then((response) => {
            if (response.status === 200) {
                this.setState({
                    breakdownStatus: "ok",
                    breakdown: Array.isArray(response.data.operators) ? response.data.operators : [],
                })
            }
            else {
                this.setState({ breakdownStatus: "error", breakdown: [] })
            }
        }).catch(() => {
            this.setState({ breakdownStatus: "error", breakdown: [] })
        })

    }

    /* Toggle An Operator — the studios of it collapse and open back */
    toggleOperator = (id) => {

        /* Fields */
        const { collapsed } = this.state

        /* Send Result */
        this.setState({ collapsed: collapsed.includes(id) ? collapsed.filter((item) => item !== id) : [...collapsed, id] })
    }

    /* Toggle A Studio — the games of it open on demand */
    toggleStudio = (key) => {

        /* Fields */
        const { expanded } = this.state

        /* Send Result */
        this.setState({ expanded: expanded.includes(key) ? expanded.filter((item) => item !== key) : [...expanded, key] })
    }

    /* Apply Action (from the Filter widget) */
    apply = ({ selected, start, end, operators, studios, testers, vips }) => {
        this.setState({ selected, start, end, operators, studios, testers, vips }, () => this.load(true))
    }

    /* Labels Of The Periods — the same presets the players filter keeps */
    _labels = () => ({
        "3hours": t("player.last3h"),
        "6hours": t("player.last6h"),
        "12hours": t("player.last12h"),
        "today": t("player.today"),
        "yesterday": t("player.yesterday"),
        "7days": t("player.last7days"),
        "14days": t("player.last14days"),
        "30days": t("player.last30days"),
        "month": t("player.thisMonth"),
        "prevmonth": t("player.prevMonth"),
        "period": t("player.filterPeriod"),
        "all": t("player.allTime"),
    })

    /* Get Filter Date */
    getFilterDate = () => {

        /* Fields */
        const { selected, start, end } = this.state
        const labels = this._labels()

        /* Check Period */
        if (selected === "all" || !start || !end) {
            return { filter: labels.all, text: "" }
        }

        /* Send Result */
        return {
            filter: labels[selected] ? labels[selected] : labels.period,
            text: `${moment(start).format("DD MMM YYYY")} - ${moment(end).format("DD MMM YYYY")}`,
        }
    }

    /* Count Of The Extra Filters — the badge of the period button */
    getCount = () => {

        /* Fields */
        const { operators, studios, testers, vips } = this.state
        let count = 0

        if (operators.length > 0) {
            count = count + 1
        }

        if (studios.length > 0) {
            count = count + 1
        }

        if (testers) {
            count = count + 1
        }

        if (!vips) {
            count = count + 1
        }

        /* Send Result */
        return count
    }

    /* Percentage Of The Money — how much of the debit stayed in the house */
    getPercentage = (debit, total) => {

        /* Check Debit */
        if (!debit || parseFloat(debit) <= 0) {
            return 0
        }

        /* Send Result */
        return Number(parseFloat(total) / parseFloat(debit) * 100).toFixed(0)
    }

    /* Games Of The Active Tab */
    getGames = () => {

        /* Fields */
        const { games, type } = this.state

        /* Send Result */
        return games.filter((item) => item.type === type)
    }

    /* Word Of The Players Counter */
    getPlayersWord = (players) => {

        /* Many */
        if (players > 4) {
            return t("dashboard.playersWord5")
        }

        /* One */
        if (players === 1 || players === 0) {
            return t("dashboard.playersWord1")
        }

        /* Few */
        return t("dashboard.playersWord24")
    }

    /* One Row Of A Report — the very same formatting the games table keeps */
    _reportRow = (name, item) => ({
        name,
        players: utils.checkValue(item.players, "0"),
        rounds: utils.checkValue(item.rounds, "0"),
        transactions: utils.checkValue(item.transactions, "0"),
        debit: utils.convertor(parseFloat(Math.abs(item.debit)), "$", 0, " "),
        credit: utils.convertor(parseFloat(Math.abs(item.credit)), "$", 0, " "),
        total: `${item.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(item.total)), "$", 0, " ")}`,
    })

    /* Flat Rows Of The Breakdown — an operator, its studios and the games of every studio */
    _breakdownRows = () => {

        /* Fields */
        const { breakdown } = this.state
        const rows = []

        /* Walk Every Operator */
        breakdown.forEach((operator) => {

            /* Operator */
            rows.push({ level: "operator", name: utils.checkValue(operator.name, t("dashboard.breakdownUnknown")), item: operator })

            /* Studios Of The Operator */
            operator.studios.forEach((studio) => {

                /* Studio */
                rows.push({ level: "studio", name: utils.checkValue(studio.name, "—"), item: studio })

                /* Games Of The Studio */
                studio.games.forEach((game) => {
                    rows.push({ level: "game", name: utils.checkValue(game.name, game.slug), item: game })
                })

            })

        })

        /* Send Result */
        return rows
    }

    /* Download Excel */
    downloadExcel = () => {

        /* Fields */
        const { totals, breakdown } = this.state
        const games = this.getGames()

        /* Check Data */
        if (games.length === 0 && breakdown.length === 0) {
            return
        }

        /* Title */
        const filtered = this.getFilterDate()
        const title = `${t("dashboard.gamesReport")} ${String(filtered.filter).toUpperCase()} (${filtered.text})`

        /* Prepare Header */
        const header = {
            name: t("dashboard.reportGameName"),
            players: t("dashboard.reportPlayers"),
            rounds: t("dashboard.reportRounds"),
            transactions: t("dashboard.transactions"),
            debit: t("dashboard.reportDebit"),
            credit: t("dashboard.reportCredit"),
            total: "TOTAL (GGR)",
        }

        const body = [{ name: title }, { name: "" }, header]

        /* Prepare Body */
        games.forEach((game) => {
            body.push({
                name: utils.checkValue(game.name, "-"),
                players: utils.checkValue(game.players, "0"),
                rounds: utils.checkValue(game.rounds, "0"),
                transactions: utils.checkValue(game.transactions, "0"),
                debit: utils.convertor(parseFloat(Math.abs(game.debit)), "$", 0, " "),
                credit: utils.convertor(parseFloat(Math.abs(game.credit)), "$", 0, " "),
                total: `${game.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(game.total)), "$", 0, " ")}`,
            })
        })

        /* Space */
        body.push({ name: "" })

        /* Prepare Total */
        body.push({
            name: t("dashboard.reportTotal"),
            players: utils.checkValue(totals.players, "0"),
            rounds: utils.checkValue(totals.rounds, "0"),
            transactions: utils.checkValue(totals.transactions, "0"),
            debit: utils.convertor(parseFloat(Math.abs(totals.debit)), "$", 0, " "),
            credit: utils.convertor(parseFloat(Math.abs(totals.credit)), "$", 0, " "),
            total: `${totals.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(totals.total)), "$", 0, " ")}`,
        })

        /* BREAKDOWN — EVERY OPERATOR BY EVERY STUDIO, ALL THE GAMES UNDER THEM, RIGHT UNDER THE TABLE ABOVE */
        if (breakdown.length > 0) {

            /* Space And Title */
            body.push({ name: "" })
            body.push({ name: "" })
            body.push({ name: String(t("dashboard.breakdownReport")).toUpperCase() })
            body.push({ name: "" })

            /* Header Of The Breakdown */
            body.push({
                ...header,
                name: `${t("dashboard.breakdownOperator")} / ${t("dashboard.breakdownStudio")} / ${t("dashboard.breakdownGame")}`,
            })

            /* Rows — the level of a row keeps its indent */
            this._breakdownRows().forEach((row) => {

                /* Indent Of The Level */
                const indent = row.level === "operator" ? "" : row.level === "studio" ? "    " : "        "

                /* Push Row */
                body.push(this._reportRow(`${indent}${row.name}`, row.item))
            })

        }

        /* Call Download Excel */
        downloadXlsx({
            fileName: `${t("dashboard.gamesReport")} ${String(filtered.filter).toUpperCase()}`,
            sheet: t("dashboard.reportSheet"),
            tablePayload: { header: [], body },
        })

    }

    /* Download PDF */
    downloadPDF = () => {

        /* Fields */
        const { totals, breakdown } = this.state
        const games = this.getGames()

        /* Check Data */
        if (games.length === 0 && breakdown.length === 0) {
            return
        }

        /* Start Loading */
        this.setState({ downloading: "pdf" })

        /* Title */
        const filtered = this.getFilterDate()
        const title = `${t("dashboard.gamesReport")} ${String(filtered.filter).toUpperCase()} (${filtered.text})`

        /* Build Off-screen Table (browser renders Cyrillic into canvas) */
        const container = document.createElement("div")
        container.style.position = "fixed"
        container.style.left = "-10000px"
        container.style.top = "0"
        container.style.width = "1400px"
        container.style.background = "#ffffff"
        container.innerHTML = `${this._reportHTML(title, games, totals)}${this._breakdownHTML()}`
        document.body.appendChild(container)

        /* Rasterize And Slice Into A4 Landscape Pages */
        html2canvas(container, { scale: 2, backgroundColor: "#ffffff" }).then((canvas) => {

            document.body.removeChild(container)

            const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" })
            const pageWidth = doc.internal.pageSize.getWidth()
            const pageHeight = doc.internal.pageSize.getHeight()
            const imgWidth = pageWidth
            const imgHeight = (canvas.height * imgWidth) / canvas.width
            const imgData = canvas.toDataURL("image/png")

            let heightLeft = imgHeight
            let position = 0

            doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight)
            heightLeft -= pageHeight

            while (heightLeft > 0) {
                position -= pageHeight
                doc.addPage()
                doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight)
                heightLeft -= pageHeight
            }

            doc.save(`${title}.pdf`)
        }).catch(() => {
            if (container.parentNode) {
                document.body.removeChild(container)
            }
            Swal.fire(utils.notification(t("swal.generic"), "error", 2000))
        }).finally(() => {
            this.setState({ downloading: null })
        })
    }

    /* Escape HTML (report values come from DB, guard against markup) */
    _escape = (value) => {
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
    }

    /* Build Report HTML For PDF Capture */
    _reportHTML = (title, games, totals) => {

        /* Columns — same fields/formatting as the XLSX report */
        const columns = [
            { label: t("dashboard.reportGameName"), value: (g) => utils.checkValue(g.name, "-"), align: "left" },
            { label: t("dashboard.reportPlayers"), value: (g) => utils.checkValue(g.players, "0"), align: "center" },
            { label: t("dashboard.reportRounds"), value: (g) => utils.checkValue(g.rounds, "0"), align: "center" },
            { label: t("dashboard.transactions"), value: (g) => utils.checkValue(g.transactions, "0"), align: "center" },
            { label: t("dashboard.reportDebit"), value: (g) => utils.convertor(parseFloat(Math.abs(g.debit)), "$", 0, " "), align: "right" },
            { label: t("dashboard.reportCredit"), value: (g) => utils.convertor(parseFloat(Math.abs(g.credit)), "$", 0, " "), align: "right" },
            { label: "TOTAL (GGR)", value: (g) => `${g.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(g.total)), "$", 0, " ")}`, color: (g) => (g.total >= 0 ? "#4c9a2a" : "#d32f2f"), align: "right" },
        ]

        /* Header */
        const head = columns.map((c) =>
            `<th style="padding:8px 10px; text-align:${c.align}; border-bottom:2px solid #333; font-weight:700; white-space:nowrap;">${this._escape(c.label)}</th>`
        ).join("")

        /* Body */
        const rows = games.map((g, index) => {
            const background = index % 2 === 0 ? "#ffffff" : "#f6f6f6"
            const cells = columns.map((c) => {
                const color = c.color ? `color:${c.color(g)}; font-weight:600;` : ""
                return `<td style="padding:7px 10px; text-align:${c.align}; border-bottom:1px solid #e5e5e5; white-space:nowrap; ${color}">${this._escape(c.value(g))}</td>`
            }).join("")
            return `<tr style="background:${background};">${cells}</tr>`
        }).join("")

        /* Total Row */
        const total = [
            { value: t("dashboard.reportTotal"), align: "left" },
            { value: utils.checkValue(totals.players, "0"), align: "center" },
            { value: utils.checkValue(totals.rounds, "0"), align: "center" },
            { value: utils.checkValue(totals.transactions, "0"), align: "center" },
            { value: utils.convertor(parseFloat(Math.abs(totals.debit)), "$", 0, " "), align: "right" },
            { value: utils.convertor(parseFloat(Math.abs(totals.credit)), "$", 0, " "), align: "right" },
            { value: `${totals.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(totals.total)), "$", 0, " ")}`, align: "right", color: totals.total >= 0 ? "#4c9a2a" : "#d32f2f" },
        ].map((c) => {
            const color = c.color ? `color:${c.color};` : ""
            return `<td style="padding:9px 10px; text-align:${c.align}; border-top:2px solid #333; font-weight:700; white-space:nowrap; ${color}">${this._escape(c.value)}</td>`
        }).join("")

        return `
            <div style="padding:24px; font-family: Arial, sans-serif; color:#111;">
                <div style="font-size:18px; font-weight:700; margin-bottom:16px;">${this._escape(title)}</div>
                <table style="width:100%; border-collapse:collapse; font-size:12px;">
                    <thead><tr>${head}</tr></thead>
                    <tbody>${rows}<tr style="background:#ffffff;">${total}</tr></tbody>
                </table>
            </div>
        `
    }

    /* Build The Breakdown HTML For PDF Capture — every operator by every studio, all the games under them */
    _breakdownHTML = () => {

        /* Fields */
        const rows = this._breakdownRows()

        /* Check Rows */
        if (rows.length === 0) {
            return ""
        }

        /* Columns — the same fields the games table above keeps */
        const columns = [
            { label: `${t("dashboard.breakdownOperator")} / ${t("dashboard.breakdownStudio")} / ${t("dashboard.breakdownGame")}`, value: (row) => row.name, align: "left" },
            { label: t("dashboard.reportPlayers"), value: (row) => utils.checkValue(row.item.players, "0"), align: "center" },
            { label: t("dashboard.reportRounds"), value: (row) => utils.checkValue(row.item.rounds, "0"), align: "center" },
            { label: t("dashboard.transactions"), value: (row) => utils.checkValue(row.item.transactions, "0"), align: "center" },
            { label: t("dashboard.reportDebit"), value: (row) => utils.convertor(parseFloat(Math.abs(row.item.debit)), "$", 0, " "), align: "right" },
            { label: t("dashboard.reportCredit"), value: (row) => utils.convertor(parseFloat(Math.abs(row.item.credit)), "$", 0, " "), align: "right" },
            { label: "TOTAL (GGR)", value: (row) => `${row.item.total >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(row.item.total)), "$", 0, " ")}`, color: (row) => (row.item.total >= 0 ? "#4c9a2a" : "#d32f2f"), align: "right" },
        ]

        /* Header */
        const head = columns.map((c) =>
            `<th style="padding:8px 10px; text-align:${c.align}; border-bottom:2px solid #333; font-weight:700; white-space:nowrap;">${this._escape(c.label)}</th>`
        ).join("")

        /* Body — the level of a row paints it and keeps its indent */
        const body = rows.map((row) => {

            /* Style Of The Level */
            const operator = row.level === "operator"
            const studio = row.level === "studio"
            const background = operator ? "#e9eef7" : studio ? "#f6f6f6" : "#ffffff"
            const weight = operator ? 700 : studio ? 600 : 400
            const indent = operator ? 0 : studio ? 18 : 36

            /* Cells */
            const cells = columns.map((c, index) => {
                const color = c.color ? `color:${c.color(row)}; font-weight:600;` : ""
                const padding = index === 0 ? `padding:7px 10px 7px ${10 + indent}px;` : "padding:7px 10px;"
                return `<td style="${padding} text-align:${c.align}; border-bottom:1px solid #e5e5e5; white-space:nowrap; font-weight:${weight}; ${color}">${this._escape(c.value(row))}</td>`
            }).join("")

            return `<tr style="background:${background};">${cells}</tr>`
        }).join("")

        return `
            <div style="padding:24px; font-family: Arial, sans-serif; color:#111;">
                <div style="font-size:18px; font-weight:700; margin-bottom:16px;">${this._escape(t("dashboard.breakdownReport"))}</div>
                <table style="width:100%; border-collapse:collapse; font-size:12px;">
                    <thead><tr>${head}</tr></thead>
                    <tbody>${body}</tbody>
                </table>
            </div>
        `
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const { selected, start, end, operators, studios, testers, vips, downloading } = this.state

        /* Period Of The Button */
        const date = this.getFilterDate()
        const count = this.getCount()

        return (
            <div className="page-header dsh--header">

                <h1>{t("dashboard.title")}</h1>

                <div className="dsh--tools">

                    <div
                        onClick={() => this._filterModal.open({ selected, start, end, operators, studios, testers, vips })}
                        className={`dsh--period ${count > 0 ? "active" : ""}`}
                    >

                        <CalendarIcon size={15} />

                        <div className="dsh--period-text">
                            <div className="dsh--period-type">{date.filter}</div>
                            {date.text !== "" && <div className="dsh--period-value">{date.text}</div>}
                        </div>

                        {count > 0 &&
                            <div className="dsh--period-more">
                                <FilterIcon size={12} />
                                <span>{count}</span>
                            </div>
                        }

                    </div>

                    {/* Draw Reports */}
                    <Report excel={this.downloadExcel} pdf={this.downloadPDF} downloading={downloading} />

                </div>

            </div>
        )
    }

    /* TOP WIDGET */
    _top = () => {

        /* Fields */
        const { totals } = this.state
        const percentage = this.getPercentage(totals.debit, totals.total)

        return (
            <div className="dashboard-top-widget">

                {/* BATTERY WIDGET */}
                <div className="dashboard-battery-widget">

                    <div className="dashboard-battery-widget-container">
                        <div className="dashboard-battery-widget-layout">
                            {percentage && Math.abs(percentage) > 0 &&
                                <div className={`dashboard-battery-widget-container-inner ${percentage > 0 ? "green" : "red"}`} style={{ width: `${Math.abs(percentage)}%` }}>
                                    <div className="dashboard-battery-widget-container-text">{percentage}%</div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="dashboard-battery-numbers">

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/increase.png" alt="Increase" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">Debit <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className="dashboard-battery-widget-box-value">+ {utils.convertor(parseFloat(Math.abs(totals.debit)), "$", 0, " ")}</div>
                            </div>
                        </div>

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/decrease.png" alt="Decrease" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">Credit <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className="dashboard-battery-widget-box-value">- {utils.convertor(parseFloat(Math.abs(totals.credit)), "$", 0, " ")}</div>
                            </div>
                        </div>

                        <div className="dashboard-battery-widget-box">
                            <img src="/dashboard/calculate.png" alt="Increase" />
                            <div className="dashboard-battery-widget-box-text">
                                <div className="dashboard-battery-widget-box-key">{t("dashboard.profit")} <img src="/images/similar.png" alt="Calculate" /></div>
                                <div className={`dashboard-battery-widget-box-value ${totals.total >= 0 ? "green" : "red"}`}>
                                    {totals.total >= 0 ? "+ " : "- "}
                                    {utils.convertor(parseFloat(Math.abs(totals.total)), "$", 0, " ")}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="dashboard-top-numbers-widget">

                    {/* ANGLE WIDGET */}
                    <div className="dashboard-top-angle-widget">
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.visitors")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(totals.visitors, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.players")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(totals.players, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.rounds")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(totals.rounds, "-")}</div>
                        </div>
                        <div className="dashboard-top-angle-widget-box">
                            <div className="dashboard-top-angle-widget-text">{t("dashboard.games")}</div>
                            <div className="dashboard-top-angle-widget-value">{utils.checkValue(totals.tables, "-")}</div>
                        </div>
                    </div>

                    {/* INSTRUMENTS WIDGET */}
                    <div className="dashboard-top-instuments-widget">

                        <div onClick={() => this._notesModal.open()} className="dashboard-top-instument-note">
                            <img src="/images/game/writing.png" alt="Note" />
                            <div className="dashboard-top-instument-text">{t("dashboard.notes")}</div>
                        </div>

                        <div className="dashboard-top-instument-activity">
                            <img src="/images/activity.png" alt="Activity" />
                            <div className="dashboard-top-instument-text">{t("dashboard.activity")}</div>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

    /* Draw The Cover Of A Game — the picture when the table keeps one, the letter otherwise */
    _cover = (item) => {

        return (
            <div className="dashboard-game-cover">
                {item.gameImg
                    ? <img src={`${env.mediapoint}images/table-images/${item.gameImg}`} alt="Game" />
                    : <span>{String(utils.checkValue(item.name, "?")).charAt(0)}</span>
                }
            </div>
        )
    }

    /* Draw One Number Of A Row — the tone paints the icon, the value keeps it only for the money */
    _box = (icon, key, value, tone = "", colored = false) => {

        return (
            <div className={`dashboard-game-box ${tone}`}>
                <div className="dashboard-game-box-icon">{icon}</div>
                <div className="dashboard-game-box-text">
                    <div className="dashboard-game-box-key">{key}</div>
                    <div className={`dashboard-game-box-value ${colored ? tone : ""}`}>{value}</div>
                </div>
            </div>
        )
    }

    /* Draw One Row Of The List */
    _game = (item, index) => {

        /* Fields */
        const percentage = this.getPercentage(item.debit, item.total)
        const positive = parseFloat(item.total) >= 0
        const popular = index === 0 && parseFloat(item.debit) > 0

        return (
            <Link
                to={`/table/${item.game}/${item.uid}`}
                className={`dashboard-game-row ${popular ? "popular" : ""}`}
                style={{ "--game-color": utils.checkValue(item.backColor, "#3f51b5") }}
                key={`${item.uid}-${index}`}
            >

                {/* Draw Cover */}
                {this._cover(item)}

                {/* Title */}
                <div className="dashboard-game-head">

                    {popular &&
                        <div className="dashboard-game-tags">
                            <div className="dashboard-game-tag">
                                <FireIcon size={12} />
                                <span>Popular</span>
                            </div>
                        </div>
                    }

                    <div className="dashboard-game-name">{utils.checkValue(item.name, item.slug)}</div>

                    <div className="dashboard-game-note">
                        <b>{item.players} {this.getPlayersWord(item.players)}</b>
                        <i />
                        {utils.checkValue(item.studio, "—")}
                    </div>

                </div>

                {/* Numbers */}
                <div className="dashboard-game-numbers">

                    {this._box(<DebitIcon size={16} />, "Debit", `+ ${utils.convertor(parseFloat(Math.abs(item.debit)), "$", 0, " ")}`, "blue")}

                    {this._box(<CreditIcon size={16} />, "Credit", `- ${utils.convertor(parseFloat(Math.abs(item.credit)), "$", 0, " ")}`, "red")}

                    {this._box(
                        <GgrIcon size={16} />,
                        "GGR",
                        `${positive ? "+ " : "- "}${utils.convertor(parseFloat(Math.abs(item.total)), "$", 0, " ")}`,
                        positive ? "green" : "red",
                        true,
                    )}

                    {this._box(<TransactionIcon size={16} />, t("dashboard.transactions"), utils.checkValue(item.transactions, "0"), "violet")}

                    {this._box(<RoundIcon size={16} />, t("dashboard.rounds"), utils.checkValue(item.rounds, "0"), "amber")}

                </div>

                {/* Profit */}
                <div className="dashboard-game-profit">

                    <div className="dashboard-game-profit-head">
                        <div className="dashboard-game-profit-key">
                            <ProfitIcon size={12} />
                            PROFIT
                        </div>
                        <div className="dashboard-game-profit-value">{percentage} %</div>
                    </div>

                    <div className="dashboard-game-profit-bar">
                        <div
                            className={`dashboard-game-profit-fill ${positive ? "" : "red"}`}
                            style={{ width: `${Math.min(Math.abs(percentage), 100)}%` }}
                        />
                    </div>

                </div>

            </Link>
        )
    }

    /* Draw Games */
    _games = () => {

        /* Fields */
        const list = this.getGames()

        /* Check Games */
        if (list.length === 0) {
            return (
                <div className="dashboard-games-empty">
                    <CardsIcon size={38} />
                    <span>{t("dsh.empty")}</span>
                </div>
            )
        }

        return (
            <div className="dashboard-games-list">
                {list.map((item, index) => this._game(item, index))}
            </div>
        )
    }

    /* Draw One Number Of A Breakdown Row */
    _bdBox = (icon, key, value, tone = "") => {

        return (
            <div className="dsh--bd-number" key={key}>
                <div className="dsh--bd-number-key">
                    {icon}
                    <span>{key}</span>
                </div>
                <div className={`dsh--bd-number-value ${tone}`}>{value}</div>
            </div>
        )
    }

    /* Draw The Numbers Of A Breakdown Row — an operator, a studio and a game keep the very same set */
    _bdNumbers = (item) => {

        /* Fields */
        const positive = parseFloat(item.total) >= 0

        return (
            <div className="dsh--bd-numbers">

                {this._bdBox(<DebitIcon size={12} />, "Debit", `+ ${utils.convertor(parseFloat(Math.abs(item.debit)), "$", 0, " ")}`, "blue")}

                {this._bdBox(<CreditIcon size={12} />, "Credit", `- ${utils.convertor(parseFloat(Math.abs(item.credit)), "$", 0, " ")}`, "red")}

                {this._bdBox(
                    <GgrIcon size={12} />,
                    "GGR",
                    `${positive ? "+ " : "- "}${utils.convertor(parseFloat(Math.abs(item.total)), "$", 0, " ")}`,
                    positive ? "green" : "red",
                )}

                {this._bdBox(<TransactionIcon size={12} />, t("dashboard.transactions"), utils.checkValue(item.transactions, "0"))}

                {this._bdBox(<RoundIcon size={12} />, t("dashboard.rounds"), utils.checkValue(item.rounds, "0"))}

                {this._bdBox(<OperatorIcon size={12} />, t("dashboard.players"), utils.checkValue(item.players, "0"))}

            </div>
        )
    }

    /* Draw One Game Of A Studio */
    _bdGame = (game, index) => {

        return (
            <Link
                to={`/table/${game.game}/${game.uid}`}
                className="dsh--bd-game"
                style={{ "--game-color": utils.checkValue(game.backColor, "#3f51b5") }}
                key={`${game.uid}-${index}`}
            >

                <div className="dsh--bd-game-name">{utils.checkValue(game.name, game.slug)}</div>

                {/* Draw Numbers */}
                {this._bdNumbers(game)}

            </Link>
        )
    }

    /* Draw One Studio Of An Operator — the games of it open on demand */
    _bdStudio = (operator, studio, index) => {

        /* Fields */
        const { expanded } = this.state
        const key = `${operator.id}-${studio.id}`
        const open = expanded.includes(key)

        return (
            <div className={`dsh--bd-studio ${open ? "open" : ""}`} key={`${key}-${index}`}>

                <div onClick={() => this.toggleStudio(key)} className="dsh--bd-studio-head">

                    <div className="dsh--bd-studio-title">
                        <StudioIcon size={14} />
                        <div className="dsh--bd-studio-name">{utils.checkValue(studio.name, "—")}</div>
                        <div className="dsh--bd-studio-count">{studio.games.length}</div>
                    </div>

                    {/* Draw Numbers */}
                    {this._bdNumbers(studio)}

                    <div className="dsh--bd-chevron">
                        <ChevronIcon size={13} />
                    </div>

                </div>

                {/* Games Of The Studio */}
                {open &&
                    <div className="dsh--bd-games">
                        {studio.games.map((game, position) => this._bdGame(game, position))}
                    </div>
                }

            </div>
        )
    }

    /* Draw One Operator — every studio it reaches sits right under it */
    _bdOperator = (operator, index) => {

        /* Fields */
        const { collapsed } = this.state
        const open = !collapsed.includes(operator.id)

        return (
            <div className={`dsh--bd-operator ${open ? "open" : ""}`} key={`${operator.id}-${index}`}>

                <div onClick={() => this.toggleOperator(operator.id)} className="dsh--bd-operator-head">

                    <div className="dsh--bd-operator-icon">
                        <OperatorIcon size={17} />
                    </div>

                    <div className="dsh--bd-operator-title">

                        <div className="dsh--bd-operator-name">{utils.checkValue(operator.name, t("dashboard.breakdownUnknown"))}</div>

                        <div className="dsh--bd-operator-note">
                            <b>{operator.studios.length}</b>
                            <span>{t("dashboard.breakdownStudiosWord")}</span>
                            <i />
                            <b>{operator.tables}</b>
                            <span>{t("dashboard.breakdownGamesWord")}</span>
                        </div>

                    </div>

                    {/* Draw Numbers */}
                    {this._bdNumbers(operator)}

                    <div className="dsh--bd-chevron">
                        <ChevronIcon size={14} />
                    </div>

                </div>

                {/* Studios Of The Operator */}
                {open &&
                    <div className="dsh--bd-studios">
                        {operator.studios.map((studio, position) => this._bdStudio(operator, studio, position))}
                    </div>
                }

            </div>
        )
    }

    /* Draw The Breakdown — EVERY OPERATOR BY EVERY STUDIO, ALL THE GAMES OF THE FILTER */
    _breakdown = () => {

        /* Fields */
        const { breakdown, breakdownStatus } = this.state

        return (
            <div className="dashboard-breakdown">

                {/* HEADER */}
                <div className="dashboard-games-header">
                    <h2>{t("dashboard.breakdownTitle")}</h2>
                </div>

                <div className="dsh--bd-note">{t("dashboard.breakdownNote")}</div>

                {/* LOADING */}
                {breakdownStatus === "loading" &&
                    <div className="dashboard-games-empty">
                        <CardsIcon size={38} />
                        <span>...</span>
                    </div>
                }

                {/* ERROR */}
                {breakdownStatus === "error" &&
                    <div className="dashboard-games-empty">
                        <CardsIcon size={38} />
                        <span onClick={() => this.loadBreakdown()} className="dsh--bd-reload">{t("dashboard.breakdownError")}</span>
                    </div>
                }

                {/* EMPTY */}
                {breakdownStatus === "ok" && breakdown.length === 0 &&
                    <div className="dashboard-games-empty">
                        <CardsIcon size={38} />
                        <span>{t("dashboard.breakdownEmpty")}</span>
                    </div>
                }

                {/* OPERATORS */}
                {breakdownStatus === "ok" && breakdown.length > 0 &&
                    <div className="dsh--bd-list">
                        {breakdown.map((item, index) => this._bdOperator(item, index))}
                    </div>
                }

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { type, status } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                {/* HEADER */}
                {this._header()}

                <div className="dashboard-container">

                    {/* TOP WIDGETS */}
                    {this._top()}

                    {/* Games */}
                    <div className="dashboard-games">

                        {/* GAME HEADER */}
                        <div className="dashboard-games-header">
                            <h2>{t("dashboard.games")}</h2>
                            <div className="dashboard-games-header-types">
                                {GAME_TYPES.map((item, index) =>
                                    <div
                                        onClick={() => this.setState({ type: item.key })}
                                        className={`dashboard-games-header-type ${item.key === type ? "active" : "default"}`}
                                        key={`${index}`}
                                    >
                                        {item.text}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* GAMES */}
                        {this._games()}

                    </div>

                    {/* BREAKDOWN — EVERY OPERATOR BY EVERY STUDIO, ALL THE GAMES UNDER THEM */}
                    {this._breakdown()}

                </div>

                {/* FILTER MODAL */}
                <Filter apply={(data) => this.apply(data)} ref={(ref) => this._filterModal = ref} />

                {/* NOTES MODAL — every note the token reaches, narrowed down by a game */}
                <Notes ref={(ref) => this._notesModal = ref} />

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

export default connect(mapStateToProps)(Dashboard)
